import { getViewport, getChildSlot } from 'lib-utils'

const featuredCarousels = document.querySelectorAll(
  '.js-featured-collection-slide'
)

const disabledClassName = 'carousel__navigation-button--disabled'

const iconStyle = {
  enabled: {
    textColor: 'var(--nova-brand-light)',
    backgroundColor: 'var(--nova-color-queer-purple)',
  },
  disabled: {
    textColor: 'var(--nova-utility-grey-4)',
    backgroundColor: 'var(--nova-utility-grey-2)',
  },
}

document.addEventListener('DOMContentLoaded', () => {
  if (featuredCarousels.length === 0) return

  updateFeaturedSlideAttribute()
  applyStyleToIcon(disabledClassName, iconStyle, featuredCarousels)
  observeFeaturedInertAttributes()

  window.addEventListener('nova:resize-width', () => {
    updateFeaturedSlideAttribute()
  })
})

function updateFeaturedSlideAttribute() {
  for (const carousel of featuredCarousels) {
    const viewport = getViewport()
    switch (viewport) {
      case 'small-mobile':
      case 'mobile':
        carousel.setAttribute('slides-per-page', 1.5)
        break
      case 'tablet':
        carousel.setAttribute('slides-per-page', 1.5)
        break
      case 'desktop':
        carousel.setAttribute('slides-per-page', 2)
        break
      case 'large-desktop':
        carousel.setAttribute('slides-per-page', 2)
        break
      default:
        carousel.setAttribute('slides-per-page', 2)
        break
    }
    handleFeaturedCarouselBtn(carousel)
  }
}

function applyStyleToIcon(className, styleObject, carouselElements) {
  for (const carousel of carouselElements) {
    const carouselBtns = carousel.shadowRoot.querySelectorAll(
      '.carousel__navigation-button'
    )

    for (let navigationBtn of carouselBtns) {
      const iconElements = getChildSlot(navigationBtn, '.js-navigation-button')

      for (const iconSvg of iconElements) {
        const strokeColor = navigationBtn.classList.contains(className)
          ? styleObject.disabled.textColor
          : styleObject.enabled.textColor
        const backgroundColor = navigationBtn.classList.contains(className)
          ? styleObject.disabled.backgroundColor
          : styleObject.enabled.backgroundColor

        for (const iconPath of iconSvg.querySelectorAll('path')) {
          iconPath.style.stroke = strokeColor
        }

        navigationBtn.style.backgroundColor = backgroundColor
      }

      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'class'
          ) {
            const currentState = mutation.target.classList.contains(className)
            if (navigationBtn !== currentState) {
              navigationBtn = currentState
              applyStyleToIcon(className, styleObject, carouselElements)
            }
          }
        }
      })

      observer.observe(navigationBtn, { attributes: true })
    }
  }
}

const handleFeaturedCarouselBtn = (carousel) => {
  const carouselBase = carousel.shadowRoot.querySelector('#scroll-container')
  const carouselBtns = carousel.shadowRoot.querySelectorAll(
    '.carousel__navigation-button'
  )
  if (carouselBtns.length === 0 || !carouselBase) return
  if (window.innerWidth < 768) return
  for (const btn of carouselBtns) {
    btn.style.display =
      carouselBase.scrollWidth > carouselBase.clientWidth ? 'flex' : 'none'
  }
}

const observeFeaturedInertAttributes = () => {
  for (const carousel of featuredCarousels) {
    const carouselItems = carousel.querySelectorAll('sl-carousel-item')
    for (const item of carouselItems) {
      const observer = new MutationObserver((mutations) => {
        for (const mutation of mutations) {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'inert'
          ) {
            item.removeAttribute('inert')
          }
        }
      })
      observer.observe(item, { attributes: true })
    }
  }
}
